<div class="outer_div">
    <div class="square_shape">
        <img src="../../../assets/images/home_banner.jpg" alt="grammar checker">
        <div class="in_side_images">
        </div>
    </div>
</div>

<div class="academic-writing">
    <div class="container">
        <div class="row">
            <!-- data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" -->
            <div class="col-xl-8">
                <h1 class="main-title ">Gramática e escrita do jeito certo</h1>
                <p>Trinka é a melhor ferramenta de correção de gramática e linguagem IA para redação acadêmica e técnica.</p>
                <ul class="highted-points">
                    <li>Mais de 3000 verificações gramaticais</li>
                    <li>Dicas avançadas de escrita</li>
                    <li>Melhorias de tom e estilo</li>
                    <li>Funciona em todos os assuntos e àreas</li>
                </ul>
                <div class="col-md-12">
                    <div class="banner-btns">
                        <a id="homeSignUpforFree" href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">
                            <i class="fa fa-sign-in"></i>Cadastre-se Grátis</a>
                        <!-- <button> <i class="fa fa-sign-in"></i> Sign up for Free</button> -->
                        <!-- no_hover -->
                        <!-- <div class="banner-btns-inner">
                            <a id="goToTrinkaCloud" href="https://cloud.trinka.ai" target="_blank">
                                <div class="icons">
                                    <img src="../../../assets/images/Get_stated_online_icons.png" alt="trinka-cloud-english-correction">
                                </div>
                                <div class="banner-txt">
                                    <span class="purple-text" style="font-size: 22px;">Sign up for Free</span>
                                    <span class="purple-text">Start writing better now</span>
                                    <p>Log into Trinka Cloud</p>
                                </div>
                            </a>
                        </div> -->

                        <!-- <div class="banner-btns-inner">
                            <a id="goToWordPlugin" [routerLink]="['/wordplugin']">
                                <div class="icons">
                                    <img src="../../../assets/images/download_trinka_icon.png" alt="grammar-checker-word-plugin">
                                </div>
                                <div class="banner-txt">
                                    <span class="purple-text">Coming soon !</span>
                                    <p>FREE Microsoft Word plug-in</p>
                                </div>
                            </a>
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" -->
            <div class="col-xl-4">
                <div class="technical-writing">
                    <div class="technical-writing-slider">
                        <section class="slide-wrapper">
                            <div class="hub-slider">
                                <div class="hub-slider-slides">
                                    <ul>
                                        <li>
                                            <div class="slider-card">
                                                <p>
                                                    <span>On the other hand</span>
                                                    <span class="themeColor">However,</span> additional factors
                                                    <span>which influence</span>
                                                    <span class="themeColor">influencing</span> patient prognosis and
                                                    <span>leading to a reduction in</span>
                                                    <span class="themeColor">reducing</span> HDL-C and Apo A1 levels were assessed.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Apo A1 levels
                                                    <span>are</span> appeared to
                                                    <span>negatively correlate
                                                    </span>
                                                    <span class="themeColor">correlate negatively</span> with hs-CRP levels [11], consistent with
                                                    our findings.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>This result
                                                    <span>may</span>
                                                    <span class="themeColor">may be</span>
                                                    <span>attribute</span>
                                                    <span class="themeColor">attributed to</span>
                                                    patients appendectomized for over 20 years being older than the controls.
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                                    <span>transverse myelitis with long spinal cord lesions</span>
                                                    <span class="themeColor">longitudinally extensive transverse myelitis</span>.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>The
                                                    <span>retarded children</span>
                                                    <span class="themeColor">children with mental retardation</span> were taken to a different facility.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="slider-card">
                                                <p>Utilities would continue to
                                                    <span>have the obligation</span>
                                                    <span class="themeColor">be obliged</span> to serve retail customers.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div class="hub-slider-controls">
                                    <button class="hub-slider-arrow hub-slider-arrow_next">
                                        <i class="fa fa-chevron-up"></i>
                                    </button>
                                    <button class="hub-slider-arrow hub-slider-arrow_prev">
                                        <i class="fa fa-chevron-down"></i>
                                    </button>
                                </div>

                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="for_mobile_contents">
    <div class="mobile_slider_overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000">
                <div class="academic_writing_section main_slider_homepage">
                    <div class="container">
                        <div class="academic_slider_section">
                            <div id="main_slider" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <p>
                                            <span>On the other hand</span>
                                            <span class="themeColor">However</span>, additional factors
                                            <span>which influence</span>
                                            <span class="themeColor">influencing</span> patient prognosis and
                                            <span>leading to a reduction in</span>
                                            <span class="themeColor">reducing</span> HDL-C and Apo A1 levels were assessed.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>Apo A1 levels
                                            <span>are</span> appeared to
                                            <span>negatively correlate</span>
                                            <span class="themeColor">correlate negatively</span> with hs-CRP levels [11], consistent with our findings.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>This result
                                            <span>may</span>
                                            <span class="themeColor">may be</span>
                                            <span>attribute</span>
                                            <span class="themeColor">attributed to</span>
                                            patients appendectomized for over 20 years, being older than the controls.
                                        </p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>Anti-aquaporin 4 antibody testing may be useful in cases of pediatric
                                            <span>transverse myelitis with long spinal cord lesions</span>
                                            <span class="themeColor">longitudinally extensive transverse myelitis</span>.</p>
                                    </div>
                                    <div class="carousel-item">
                                        <p>The
                                            <span>retarded children</span>
                                            <span class="themeColor">children with mental retardation</span> were taken to a different facility.</p>
                                    </div>

                                    <div class="carousel-item">
                                        <p>Utilities would continue to
                                            <span>have the obligation</span>
                                            <span class="themeColor">be obliged</span> to serve retail customers.</p>
                                    </div>


                                    <a class="carousel-control-prev" href="#main_slider" data-slide="prev">
                                        <span>
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;"
                                                xml:space="preserve">
                                                <g>
                                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                    <a class="carousel-control-next" href="#main_slider" data-slide="next">
                                        <span>
                                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;"
                                                xml:space="preserve">
                                                <g>
                                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                    <g>
                                                    </g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="academic_writing_section academic_background_shap">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="academic_writing_text">
                    <h2>Feito para redação acadêmica e técnica</h2>
                    <p>A Trinka encontra erros difíceis que são exclusivos da escrita acadêmica e que outras ferramentas não
                        encontram. De erros gramaticais complexos ao tom e estilo científico, a Trinka verifica tudo!</p>
                </div>
            </div>
        </div>

        <div class="academic_slider_section">
            <div id="subject-verb-d" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>Encontra erros complicados que os outros não econtram</h3>
                    <p>A Trinka é feita especialmente para escrita acadêmica e técnica; corrige 3000+ erros gramaticais complexos.
                        O jeito certo de escrever agora não tem estresse!</p>
                    <ul class="carousel-indicators">
                        <li data-target="#subject-verb-d" data-slide-to="0" class="active">
                            <span></span>Sujeito-verbo, pronomes antecedentes discordantes</li>
                        <li data-target="#subject-verb-d" data-slide-to="1">
                            <span></span>Sintaxe, escolha de palavras
                        </li>
                        <li data-target="#subject-verb-d" data-slide-to="2">
                            <span></span>Pronome, uso do artigo
                        </li>
                        <li data-target="#subject-verb-d" data-slide-to="3">
                            <span></span>Grafias técnicas</li>
                    </ul>
                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>Sujeito-verbo, pronomes antecedentes discordantes</h4>
                        <p>Five different experts
                            <span>was</span>
                            <span class="themeColor">were</span> asked to evaluate the individual's performance and interobserver agreement was assessed.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>Sintaxe</h4>
                        <p>Rarely
                            <span>we</span>
                            <span class="themeColor">do we</span> use aneurysm clips to obliterate the vessels.</p>
                        <!-- <p>Rarely <span class="themeColor">do</span> we use aneurysm clips to obliterate the vessels.</p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>Pronome, uso do artigo</h4>
                        <!-- <p>Every <span class="themeColor">one</span> of these studies claimed the importance of the
                            spatial externalities for economic growth.</p> -->
                        <p>
                            <span>Every</span>
                            <span class="themeColor">Every one</span> of these studies claimed the importance of the spatial externalities for economic
                            growth.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>Grafias técnicas</h4>
                        <p>It was full of
                            <span>turgid</span>
                            <span class="themeColor">turbid</span> water and on analysis, the contamination levels were found to be very high.</p>
                    </div>
                    <a class="carousel-control-prev" href="#subject-verb-d" data-slide="prev">
                        <span>
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#subject-verb-d" data-slide="next">
                        <span>
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="or-spacer">
                <!-- <div class="mask"></div> -->
            </div>
        </div>
    </div>
</div>


<div class="academic_writing_section beyond_grammer_spelling_sections footer_shap_background">
    <div class="container">

        <div class="academic_slider_section">
            <div id="spelling_grammers" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>Melhora a escrita além da gramática e ortografia</h3>
                    <p>Trinka vai além da gramática e melhora sua escrita para vocabulário, tom, sintaxe e muito mais. Expresse
                        seu ponto de vista com confiança, com a Trinka.</p>
                    <ul class="carousel-indicators">
                        <li data-target="#spelling_grammers" data-slide-to="0" class="active">
                            <i>
                                <img src="../../../assets/images/style_guides_icon.png" alt="trinka-service-apa-ama-style">
                            </i>
                            Guias de estilo (APA | AMA)
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="1">
                            <i>
                                <img src="../../../assets/images/scientific_tone_icon.png" alt="scientific-tone-grammar-check" />
                            </i>
                            Tom científico
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="2">
                            <i>
                                <img src="../../../assets/images/technical_word_choice_icon.png" alt="technical-word-grammar-check" />
                            </i>
                            Escolha técnica de palavras
                        </li>
                        <li data-target="#spelling_grammers" data-slide-to="3">
                            <i>
                                <img src="../../../assets/images/word_count_reduction_icon.png" alt="word-count-reduction-grammar-checker" />
                            </i>
                            Concisão
                        </li>
                    </ul>
                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>Guias de estilo</h4>
                        <p>The
                            <span>males</span>
                            <span class="themeColor">men</span> scored higher than the
                            <span>females</span>
                            <span class="themeColor">women.</span>
                        </p>
                        <!-- <p>This system <span>is comprised of</span> <span class="themeColor">comprises</span> two
                            separate holding fixtures for the head.</p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>Tom científico</h4>
                        <p>However, this method is novel and is
                            <span>very much</span>
                            <span class="themeColor">significantly</span> different from the classical method.</p>
                        <!-- <p>They <span>reached a decision</span> <span class="themeColor">decided</span> to ban 5
                            countries from the games next year.</p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>Escolha técnica da palavra</h4>
                        <p>The CNTs also could enhance the resistance to photo degradation by UV irradiation during
                            <span>cyclical</span>
                            <span class="themeColor">cyclic</span> ageing tests.</p>
                        <!-- <p>They may have an <span>affect</span> <span class="themeColor">effect</span> on the tendon.</p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>Concisão</h4>
                        <p>Studies
                            <span>were carried out to evaluate</span>
                            <span class="themeColor"> evaluated</span>
                            the effect of lower temperatures on energy consumption.
                        </p>
                    </div>
                    <a class="carousel-control-prev" href="#spelling_grammers" data-slide="prev">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#spelling_grammers" data-slide="next">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="or-spacer">
                <!-- <div class="mask"></div> -->
            </div>
        </div>
    </div>
</div>



<div class="academic_writing_section beyond_grammer_spelling_sections suggests_corrections_slider">
    <div class="container">

        <div class="academic_slider_section">
            <div id="suggests_corrections" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <div class="bullet_points_sections">
                    <h3>Sugere correções relevantes para o seu texto</h3>
                    <p>A Trinka aprendeu com os trabalhos mais bem escritos em cada àrea de assunto para oferecer as melhores
                        sugestões. Com a Trinka, sua escrita será sempre precisa.</p>
                    <span class="top_diviedLine"></span>
                    <ul class="carousel-indicators">
                        <li data-target="#suggests_corrections" data-slide-to="0" class="active">
                            <!-- <a><img src="../../../assets/images/medicine.png" class="img-fluid" /></a>  -->
                            <i>Medicina</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="1">
                            <!-- <a><img src="../../../assets/images/biology.png" class="img-fluid" /></a>  -->
                            <i>Biologia</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="2">
                            <!-- <a><img src="../../../assets/images/physics-icons.png" class="img-fluid" /></a>  -->
                            <i>Física</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="3">
                            <!-- <a><img src="../../../assets/images/social-science.png" class="img-fluid" /></a>  -->
                            <i>Ciências Sociais</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="4">
                            <!-- <a><img src="../../../assets/images/engineering.png" class="img-fluid" /></a>  -->
                            <i>Engenharia</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="5">
                            <!-- <a><img src="../../../assets/images/chemistry.png" class="img-fluid" /></a>  -->
                            <i>Química</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="6">
                            <!-- <a><img src="../../../assets/images/geology.png" class="img-fluid" /></a>  -->
                            <i>Geologia</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="7">
                            <!-- <a><img src="../../../assets/images/computer-science.png" class="img-fluid" /></a>  -->
                            <i>Ciência da computação</i>
                        </li>

                        <li data-target="#suggests_corrections" data-slide-to="8">
                            <!-- <a><img src="../../../assets/images/business-and-economics.png" class="img-fluid" /></a> -->
                            <i>Economia</i>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                </div>

                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <h4>Medicina</h4>
                        <p>In general, the ADT group had a more
                            <span>advance</span>
                            <span class="themeColor">advanced</span> disease compared with the non-ADT group.
                        </p>
                        <!-- <p><span>Trinka</span> is your personal <span> AI editor</span> for all your academic writing
                            needs. <span>Trinka </span> is your personal <span> AI editor</span> for all your
                            <span>academic</span></p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>Biologia</h4>
                        <!-- <p>A current is sent through the material; consequently polarizing the electrons are polarized.</p> -->
                        <p>The membranes were then incubated with human cleaved caspase-3 antibodies at 4°C
                            <span>for</span> overnight.</p>
                        <!-- <p><span>Trinka</span> is your personal <span> AI editor</span> for all your academic writing
                            needs. <span>Trinka </span> is your personal <span> AI editor</span> for all your
                            <span>academic</span></p> -->
                    </div>

                    <div class="carousel-item">
                        <h4>Física</h4>
                        <p>Scientists rely on exactly
                            <span>soluble</span>
                            <span class="themeColor">solvable</span>
                            problems to describe the strange effects which have quantum mechanical origin.</p>
                    </div>

                    <div class="carousel-item">
                        <h4>Ciências Sociais</h4>
                        <p>The individual displayed
                            <span>a persistent spirit</span>
                            <span class="themeColor">persistence.</span>
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>Engenharia</h4>
                        <p>The technique has
                            <span class="themeColor">been</span> widely used for the fabrication of SiC
                            <span>fiber</span>
                            <span class="themeColor">fibers</span> with high mechanical properties.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>Química</h4>
                        <p>A current is sent through the material, consequently
                            <span class="themeColor">polarizing</span> the electrons.
                            <span>are polarized.</span>
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>Geologia</h4>
                        <p>
                            There was
                            <span class="themeColor">a</span> large tectonic movement at the end of the Mesozoic
                            <span>period</span>
                            <span class="themeColor">era</span>.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>Ciência da computação</h4>
                        <p>In
                            <span class="themeColor">the</span> testing phase,
                            <span>it's</span>
                            <span class="themeColor">its</span> label is determined using the
                            <span>triaining</span>
                            <span class="themeColor">training</span> instances mapped to a specific neuron.
                        </p>
                    </div>

                    <div class="carousel-item">
                        <h4>Economia</h4>
                        <p>The role expected
                            <span>to</span>
                            <span class="themeColor">of</span> IASB has changed when it became a member of the Financial Stability Board in 2009.</p>
                    </div>

                    <a class="carousel-control-prev" href="#suggests_corrections" data-slide="prev">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#suggests_corrections" data-slide="next">
                        <span class="">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 240.823 240.823" style="enable-background:new 0 0 240.823 240.823;" xml:space="preserve">
                                <g>
                                    <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z" />
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="purple-bg1 footer_shap_background">
    <div class="purple_background_overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <!-- wow fadeInLeft -->
                <div class="box">
                    <h3>A Trinka oferece os melhores aprimoramentos</h3>
                    <div class="box_text_content">
                        <p>A Trinka foi desenvolvida especificamente para redação acadêmica e técnica e baseia-se na experiência
                            de editores e linguistas altamente experientes. O resultado é simples — os melhores aprimoramentos
                            de linguagem.</p>
                        <div class="try_a_demo_compare">
                            <!-- <a routerLink="/try-a-demo" id="try_a_demoButtons">Try A Demo</a> -->
                            <a class="compareTrinka" id="downloadWhitepaper" routerLink="/trinka-vs-grammarly-vs-language-tool">Baixar Whitepaper</a>
                        </div>
                    </div>
                    <!-- <a [routerLink]="['/home/compare']" routerLinkActive="active" class="white-btn">Compare Trinka with
                        others</a> -->
                </div>
            </div>
            <div class="col-lg-6">
                <!-- wow fadeInLeft -->
                <div class="box">
                    <h3>A Trinka é ótima para equipes e empresas</h3>
                    <div class="box_text_content">
                        <p>Faça com que suas equipes escrevam melhor com a Trinka e obtenha preços atraentes e outros benefícios.</p>
                        <a id="learnMoreButton" [routerLink]="['/enterprise']">Saiba mais
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 31.49 31.49" style="enable-background:new 0 0 31.49 31.49;" xml:space="preserve">
                                <path d="M21.205,5.007c-0.429-0.444-1.143-0.444-1.587,0c-0.429,0.429-0.429,1.143,0,1.571l8.047,8.047H1.111
                                   C0.492,14.626,0,15.118,0,15.737c0,0.619,0.492,1.127,1.111,1.127h26.554l-8.047,8.032c-0.429,0.444-0.429,1.159,0,1.587
                                   c0.444,0.444,1.159,0.444,1.587,0l9.952-9.952c0.444-0.429,0.444-1.143,0-1.571L21.205,5.007z"
                                />
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                                <g>
                                </g>
                            </svg>
                        </a>
                    </div>
                    <div class="contact-sales">
                        <button type="button" id="contactSaleButton" data-toggle="modal" data-target="#EnterPriseContactPopup"
                            class="btn btn-primary mb-2">Saiba mais</button>
                        <!-- <form class="form-inline" id="contact-sales" [formGroup]="contactToSalesForm"
                            (ngSubmit)="contactToSales()">
                            <div class="form-group" [ngClass]="(!contactToSalesForm.get('saleFormemail').valid && contactToSalesForm.get('saleFormemail').dirty) || (contactToSalesForm.get('saleFormemail').touched && contactToSalesForm.get('saleFormemail').pristine) ? 'TextFiledError' : ''  ">
                                <mat-form-field appearance="outline">
                                    <mat-label>Enter your email address</mat-label>
                                    <input matInput placeholder="" formControlName="saleFormemail"
                                        class="form-control">
                                </mat-form-field>
                                
                            </div>
                            <button type="submit" id="contactSaleButton" class="btn btn-primary mb-2">Contact Sales</button>
                        </form> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center testi">
                <h2 class="sub-head">Depoimentos</h2>
                <p>Confira o que os usuários estão dizendo sobre Trinka</p>
            </div>
        </div>
    </div>
</div>



<div class="testimonial text-center">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="testimonial-wrap">
                    <!-- <div class="testimonal-icon">
                        <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                    </div> -->
                    <div class="testimonial-slider">
                        <div id="testi" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#testi" data-slide-to="0" class="active"></li>
                                <li data-target="#testi" data-slide-to="1"></li>
                                <li data-target="#testi" data-slide-to="2"></li>
                                <li data-target="#testi" data-slide-to="3"></li>
                                <li data-target="#testi" data-slide-to="4"></li>
                                <li data-target="#testi" data-slide-to="5"></li>
                                <li data-target="#testi" data-slide-to="6"></li>
                                <li data-target="#testi" data-slide-to="7"></li>
                                <li data-target="#testi" data-slide-to="8"></li>
                                <li data-target="#testi" data-slide-to="9"></li>
                                <li data-target="#testi" data-slide-to="10"></li>
                                <li data-target="#testi" data-slide-to="11"></li>
                                <li data-target="#testi" data-slide-to="12"></li>
                            </ol>
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="james smith">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Primeiramente, eu amo Trinka. Parabéns por desenvolverem algo que ajuda amplamente
                                                    na edição, especialmente convenções gramaticais críticas e reduções na
                                                    contagem de palavras.

                                                </p>
                                                <p class="authorNameText">James Smith</p>
                                                <span class="authorDesignationText">Editor Acadêmico, EUA</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="Rosa-Diaz-Sandoval">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Escrever textos com gramática e estilo corretos em inglês não é uma tarefa
                                                    fácil para pessoas que falam outros idiomas. Às vezes, você não consegue
                                                    encontrar pequenos erros em seu documento sem ajuda, especialmente para
                                                    redação acadêmica. Experimentei Trinka Al como ferramenta de correção
                                                    automática e fiquei bastante satisfeita com as correções sugeridas e
                                                    o feedback. Com o feedback você entende porque a mudança sugerida deve
                                                    ser levada em consideração.</p>
                                                <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                <span class="authorDesignationText">PhD em Física e Matemática, México</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="farooq rathore" />
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Uso trinka especialmente para melhorar a linguagem, gramática e sintaxe dos
                                                    manuscritos científicos que escrevo para periódicos biomédicos nacionais
                                                    e internacionais. Achei a interface amigável e o procedimento, em si,
                                                    é eficiente e descomplicado. As diferentes opções para para editar o
                                                    manuscrito conforme às necessidades me ajudam a decidir em qual área
                                                    devo focar. A edição automática é de grande ajuda e a página suplementar
                                                    com o resumo da revisão é uma excelente idéia. </p>
                                                <p class="authorNameText">Dr. Farooq Rathore</p>
                                                <span class="authorDesignationText">Professor Assistente e Chefe de Departamento, Paquistão</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jpg" alt="Georgieva-Milena">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Trinka Al é a minha escolha favorita para edição gramatical e ortográfica.
                                                    A plataforma funciona corretamente, é rápida e organizada! Estou completamente
                                                    satisfeita!
                                                </p>
                                                <p class="authorNameText">Milena Georgieva</p>
                                                <span class="authorDesignationText">Pesquisador</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="dinesh gupta">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">A ferramenta de verificação gramatical supera o Grammarly! Verifiquei novamente
                                                    alguns documentos que havia verificado anteriormente com o Grammarly.
                                                    Fiquei agradavelmente surpreso ao me deparar com tal produto originário
                                                    da Índia.
                                                </p>
                                                <p class="authorNameText">Dinesh Gupta</p>
                                                <span class="authorDesignationText">Radiologista, Índia</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="Edith-Davies">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Testei Trinka e fiquei impressionada com suas excelentes capacidades. Trinka
                                                    é melhor do que o verificador gramatical que uso. Parabéns! Falei para
                                                    os meus colegas de laboratório de pesquisa para usarem Trinka. Espero
                                                    que Trinka seja usado amplamente no meio acadêmico.
                                                </p>
                                                <p class="authorNameText">Edith Davies</p>
                                                <span class="authorDesignationText">Bolsista de Doutorado, Reino Unido</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="noor-al-rishi">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">As correções e feedback sugeridos por Trinka Al me surpreenderam. É simples
                                                    de usar e extremamente benéfico.
                                                </p>
                                                <p class="authorNameText">Noor Al-rishi</p>
                                                <span class="authorDesignationText">Bolsista de Química, Arábia Saudita</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="Nwaji-Jude">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Tem sido uma experiência maravilhosa usar Trinka e quase não consigo enviar
                                                    nenhum manuscrito sem que seja verificado por ele. Em resumo, Trinka
                                                    tem sido um salva-vidas.
                                                </p>
                                                <p class="authorNameText">Nwaji Jude</p>
                                                <span class="authorDesignationText">Pesquisador</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="stumpf curtis">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Gosto de usar Trinka como verificação final para meus documentos editados.
                                                    Trinka realmente ajuda a encontrar erros remanescentes que escapam durante
                                                    a primeira verificação. Gosto muito desta plataforma. O botão do polegar
                                                    para baixo é muito útil.

                                                </p>
                                                <p class="authorNameText">Stumpf Curtis</p>
                                                <span class="authorDesignationText">Pesquisador</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="dyke gareth">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Acho Trinka Al uma ideia muito interessante e potencialmente útil, especialmente
                                                    para editores/periódicos. Eu achei trinka muito útil quando verifiquei
                                                    o meu trabalho de edição na plataforma.
                                                </p>
                                                <p class="authorNameText">Gareth Dyke</p>
                                                <span class="authorDesignationText">Pesquisador</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="bhargava sharma">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Estou feliz com o desempenho geral. Uso Grammarly faz muito tempo, mas quando
                                                    se trata de redação acadêmica ou técnica, Trinka é definitivamente uma
                                                    opção melhor. As configurações de documentos acadêmicos e a edição automática
                                                    de arquivos são os meus recursos favoritos.
                                                </p>
                                                <p class="authorNameText">Bhargava Sharma</p>
                                                <span class="authorDesignationText">Epidemiologista, Índia</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="ralph bailey">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">Trinka tornou-se minha ferramenta favorita para correções gramaticais. As
                                                    correções com inteligência artificial e os aprimoramentos de linguagem
                                                    tornaram a escrita muito mais fácil. Agora, posso me concentrar mais
                                                    na pesquisa do que em escrever um documento livre de erros.
                                                </p>
                                                <p class="authorNameText">Ralph Bailey</p>
                                                <span class="authorDesignationText">Neurologista, EUA</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="clientPhotos shadow">
                                                <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="thomas andres">
                                            </div>
                                        </div>
                                        <div class="col-lg-9">
                                            <div class="clientMessageSection">
                                                <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                <p class="start-text">A correção gramatical e a sugestão com base no guia de estilo da AMA são
                                                    realmente impressionantes! Trinka é, de fato, a melhor ferramenta de
                                                    correção gramatical para redação médica.

                                                </p>
                                                <p class="authorNameText">Thomas Andres</p>
                                                <span class="authorDesignationText">Cardiologista, Brasil</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                            <span class="carousel-control-prev-icon"></span>
                        </a>
                        <a class="carousel-control-next" href="#testi" data-slide="next">
                            <span class="carousel-control-next-icon"></span>
                        </a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="client_rating_logo">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-3">
                <div class="client_rating_text">
                    <h2>Altamente avaliado pelos usuários em todo o mundo</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="client_logo_right">
                    <div class="row">
                        <div class="col-md-3 col-6">
                            <div class="client-rating sourceforge">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/SourceForge_logo.png"  />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustpilot">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trustpilot-1.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star"></i></li>
                                </ul>
                                <p>4 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating product-hunt">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/product-hunt.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating g2">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/G2_Crowd.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating capterra">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/capterra-inc.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating chrome-tool">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/chrome.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>4.3 out of 5</p>
                            </div>
                        </div>
                        
                        
                        <div class="col-md-3 col-6">
                            <div class="client-rating trustradius">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/trust-radius.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star-half-o active"></i></li>
                                </ul>
                                <p>8.4 out of 10</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-6">
                            <div class="client-rating software-suggest">
                                <div class="logo">
                                    <img src="../../../assets/images/global-logos/softwaresuggest-social.png" />
                                </div>
                                <ul>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                    <li><i class="fa fa-star active"></i></li>
                                </ul>
                                <p>5 out of 5</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>